import React from "react";
import Form from "react-validation/build/form";
import AuthService from "../../services/auth.service";
import swal from 'sweetalert';
import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    InputRightElement,
    InputGroup,
    Stack,
    Input,
    Box,
  } from '@chakra-ui/react'
import { useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { LightBg, ParentCard, Card } from "./style";
import { useNavigate } from "react-router-dom"

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState();
  const [showNewPassword, setShowNewPassword] = useState();
  const [successful, setSuccessful] = useState(false);

  const emailUser = AuthService.getCurrentUser().emailUser;

  const navigate = useNavigate();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      swal({
        title: "Apakah kamu yakin ingin mengganti kata sandi?",
        icon: "warning",
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Kembali",
            value: "no"
            }
        },
        dangerMode: true,
      }).then(async(value) => {
        if (value === "yes") {
        await AuthService.changePassword(emailUser, oldPassword, newPassword).then(
          () => {
            AuthService.logout();
            navigate("/");
            swal({
              title: "Kamu berhasil mengubah kata sandi",
              text: "Silakan masuk kembali!",
              icon: "success",
              button: "OK",
            });
          },
          (error) => {
            console.log(error);

            let resMessage;

            resMessage = (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

                console.log(resMessage);
                setMessage("Password lama salah");
                setSuccessful(false);
          })
        } return false;
      });
    } catch (err) {
      console.log(err);
      setMessage("Terjadi kesalahan, coba lagi")
    }
  };

      return (
          <>
          <LightBg>
              <ParentCard>
                  <Card>
                      <Stack>
                          <Box marginBottom={2}>
                              <Heading textAlign={'center'}>Ganti Kata Sandi</Heading>
                          </Box>
                          <Form 
                          onSubmit={handleChangePassword}>
                          <Box pt={6}>
                              <FormControl isRequired>
                              <FormLabel>Kata sandi lama</FormLabel>
                              <InputGroup>
                                    <Input 
                                        id="oldPassword"
                                        type={showOldPassword ? 'text' : 'password'} 
                                        placeholder='Masukkan kata sandi lama'
                                        name="password"
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        validations={[required]}/>
                                    <InputRightElement h={'full'}>
                                        <Button
                                            variant={'ghost'}
                                            onClick={() =>
                                            setShowOldPassword((showOldPassword) => !showOldPassword)
                                            }>
                                            {showOldPassword ? <ViewIcon /> : <ViewOffIcon />}
                                        </Button>
                                    </InputRightElement>
                                  </InputGroup>
                              </FormControl>
                          </Box>
                          <Box pt={4}>
                              <FormControl isRequired>
                              <FormLabel>Kata sandi baru</FormLabel>
                                  <InputGroup>
                                      <Input 
                                          id="newPassword"
                                          type={showNewPassword ? 'text' : 'password'} 
                                          placeholder='Masukkan kata sandi baru'
                                          name="password"
                                          value={newPassword}
                                          onChange={(e) => setNewPassword(e.target.value)}
                                          validations={[required]}/>
                                      <InputRightElement h={'full'}>
                                          <Button
                                              variant={'ghost'}
                                              onClick={() =>
                                              setShowNewPassword((showNewPassword) => !showNewPassword)
                                              }>
                                              {showNewPassword ? <ViewIcon /> : <ViewOffIcon />}
                                          </Button>
                                      </InputRightElement>
                                  </InputGroup>
                              </FormControl>
                          </Box>
                          <Box align={'center'}>
                              <Button 
                                  style={{background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} 
                                  mt={4} 
                                  type='submit'>
                                      <span>Simpan</span>
                              </Button>
                              {message && (
                                  <div className="form-group">
                                      <div className="alert alert-danger" role="alert">
                                      {message}
                                      </div>
                                  </div>
                              )}
                          </Box>
                          </Form>
                      </Stack>
                  </Card>
              </ParentCard>
          </LightBg>
        </>
      );
}

export default ChangePassword;